import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { TbLockAccess } from "react-icons/tb";
import { RiLockPasswordLine } from "react-icons/ri";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setHasError(false);
      setErrorMessage("");

      try {
        const { data } = await axios.get(`users?page=${page}`);
        setUsers(data.data);
        setLastPage(data.meta.last_page);
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          if (error.response.status === 401) {
            setErrorMessage("Unauthorized access.");
          } else if (error.response.status === 400) {
            setErrorMessage("Bad request. Please check your input.");
          } else if (error.response.status === 500) {
            setErrorMessage("Insufficient Permissions");
          } else {
            setErrorMessage("An error occurred. Please try again later.");
          }
        } else if (error.request) {
          // The request was made but no response was received
          if (error.message === "Network Error") {
            setErrorMessage(
              "Failed to connect to the server. Please try again later.",
            );
          } else {
            setErrorMessage("No response received. Please try again later.");
          }
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMessage("An error occurred. Please try again later.");
        }
        setHasError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`users/${id}`);
      setUsers(users.filter((user) => user.id !== id));
    }
  };

  const resetPasswd = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to reset the password for this user?",
      )
    ) {
      await axios.post(`users/${id}/reset-password`);
      // Handle success response, e.g., show a success message
    }
  };

  return (
    <Wrapper pageTitle={"Users"}>
      {loading ? (
        <p>Loading...</p>
      ) : hasError ? (
        <p className="text-lg red-600">
          {" "}
          <TbLockAccess className="text-2xl" /> {errorMessage}
        </p>
      ) : (
        <>
          <InnerNav createLink={"/userCreate"} listLink={"/users"} />
          <div className="w-full overflow-hidden rounded-lg shadow-xs">
            <div className="w-full overflow-x-auto">
              <table className="w-full whitespace-no-wrap">
                <thead>
                  <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                    <th className="px-4 py-3">#Ref </th>
                    <th className="px-4 py-3">FirstName </th>
                    <th className="px-4 py-3">LastName </th>
                    <th className="px-4 py-3">Email </th>
                    <th className="px-4 py-3">RoleId </th>
                    <th className="px-4 py-3">Action</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                  {users.map((user) => {
                    return (
                      <tr
                        key={user.id}
                        className="text-gray-700 dark:text-gray-400"
                      >
                        <td className="px-4 py-5">{user.id}</td>
                        <td className="px-4 py-3 text-sm">{user.first_name}</td>
                        <td className="px-4 py-3 text-sm">{user.last_name}</td>
                        <td className="px-4 py-3 text-sm">{user.email}</td>
                        <td className="px-4 py-3 text-sm">{user.role.name}</td>

                        <td className="flex px-4 py-3 text-sm">
                          <Link
                            className="btn btn-sm btn-outline-secondary px-5"
                            to={`/user/${user.id}/edit`}
                          >
                            <AiFillEdit />{" "}
                          </Link>
                          <span
                            className="btn btn-sm btn-outline-secondary px-5"
                            onClick={() => del(user.id)}
                          >
                            {" "}
                            <AiFillDelete className="text-rose-500 text-lg" />
                          </span>
                          <span
                            title="Reset Password"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => resetPasswd(user.id)}
                          >
                            {" "}
                            <RiLockPasswordLine className="text-blue-500 text-lg" />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Paginator lastPage={lastPage} pageChanged={setPage} />
          </div>
        </>
      )}
    </Wrapper>
  );
};
export default Users;
